import { Box, Card } from '@mui/material'

import { useEffect, useState } from 'react'
import WTypography from 'Components/whiteTypography'
import { Doughnut } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

function ReparitionCard({ oldData, updateReports }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [revData, setRevData] = useState({
    labels: oldData[0]?.label,
    datasets: [
      {
        data: oldData[0]?.data,
        // data: [80, 5, 15],
        backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
        borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
        borderWidth: 1,
        hoverOffset: 4,
        precision: 0,
      },
    ],
  })
  const optiondonut = {
    responsive: true,
    aspectRatio: 1.3,
    clip: true,

    plugins: {
      datalabels: {
        formatter: function (value, ctx) {
          return ctx.chart.data.labels[ctx.dataIndex] + '\n' + [value] + ' %'
        },
        textAlign: 'center',
        color: 'white',
        anchor: 'center',
        clamp: true,
        display: 'auto',
      },

      legend: {
        display: true,
        position: 'bottom',
        responsive: true,
        events: [],
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.yLabel
          },
        },
      },
    },
  }
  useEffect(() => {
    setRevData({
      labels: oldData[0]?.label,
      datasets: [
        {
          data: oldData[0]?.data,
          // data: [80, 5, 15],
          backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
          borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
          borderWidth: 1,
          hoverOffset: 4,
          precision: 0,
        },
      ],
    })
  }, [oldData])

  return (
    <>
      <Card className="dashboard_card__root1">
        <Box className="dashboard_card__header1">
          <WTypography component={'span'} variant="h6">
            {t('syntheseTemps.timeDistributionTitle')}
          </WTypography>
        </Box>
        <Box className="dashboard_card__header1">
          <WTypography sx={{ color: '#ffffffa1' }} variant={'body2'}>
            {t('syntheseTemps.timeDistributionSubtitle')}
          </WTypography>
        </Box>

        <Box minWidth={3} mb={8} height={'70%'}>
          <Box mt={9} className="chart_box no-drag" minWidth={3} mb={6} height={'100%'}>
            <Doughnut data={revData} options={optiondonut} />
          </Box>
        </Box>
      </Card>
    </>
  )
}

export default ReparitionCard
